// eslint-disable-next-line no-restricted-exports
export { default } from './PageHeader';
export * from './PageHeader';
